import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconDownload = ({ className }) => {
    return (
        <svg
            className={'icon-download' + (className ? ` ${className}` : '')}
            fill='none'
            height='20'
            viewBox='0 0 20 20'
            width='20'
            xmlns='http://www.w3.org/2000/svg'>

            <mask
                height='20'
                id='mask0_16335_5646'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
                width='20'
                x='0'
                y='0'>
                <rect
                    fill='#D9D9D9'
                    height='20'
                    width='20'/>
            </mask>
            <g mask='url(#mask0_16335_5646)'>
                <path
                    d='M4.75646 16.5827C4.38132 16.5827 4.06424 16.4532 3.80521 16.1941C3.54619 15.9351 3.41667 15.618 3.41667 15.2429V4.75581C3.41667 4.38067 3.54619 4.06359 3.80521 3.80456C4.06424 3.54553 4.38132 3.41602 4.75646 3.41602H9.13771C9.29146 3.41602 9.42021 3.46747 9.52396 3.57039C9.62757 3.67317 9.67938 3.80081 9.67938 3.95331C9.67938 4.10581 9.62757 4.2349 9.52396 4.3406C9.42021 4.44643 9.29146 4.49935 9.13771 4.49935H4.75646C4.6923 4.49935 4.63355 4.52608 4.58021 4.57956C4.52674 4.63289 4.50001 4.69164 4.50001 4.75581V15.2429C4.50001 15.3071 4.52674 15.3658 4.58021 15.4191C4.63355 15.4726 4.6923 15.4993 4.75646 15.4993H15.2435C15.3077 15.4993 15.3665 15.4726 15.4198 15.4191C15.4733 15.3658 15.5 15.3071 15.5 15.2429V10.8616C15.5 10.7079 15.5514 10.5791 15.6542 10.4754C15.7571 10.3718 15.8848 10.32 16.0373 10.32C16.1898 10.32 16.3189 10.3718 16.4246 10.4754C16.5304 10.5791 16.5833 10.7079 16.5833 10.8616V15.2429C16.5833 15.618 16.4538 15.9351 16.1948 16.1941C15.9358 16.4532 15.6187 16.5827 15.2435 16.5827H4.75646ZM15.5 5.27331L8.45521 12.3183C8.3398 12.4336 8.21556 12.4891 8.08251 12.485C7.94959 12.4807 7.82271 12.4182 7.70188 12.2975C7.58119 12.1766 7.52084 12.0476 7.52084 11.9104C7.52084 11.7732 7.58119 11.6441 7.70188 11.5233L14.726 4.49935H12.5417C12.3879 4.49935 12.2592 4.44796 12.1556 4.34518C12.0519 4.24227 12 4.11456 12 3.96206C12 3.80956 12.0519 3.68046 12.1556 3.57477C12.2592 3.46893 12.3879 3.41602 12.5417 3.41602H15.9133C16.1046 3.41602 16.264 3.4799 16.3917 3.60768C16.5195 3.73532 16.5833 3.89477 16.5833 4.08602V7.45768C16.5833 7.61143 16.5319 7.74011 16.429 7.84372C16.3262 7.94747 16.1985 7.99935 16.046 7.99935C15.8935 7.99935 15.7645 7.94747 15.6588 7.84372C15.5529 7.74011 15.5 7.61143 15.5 7.45768V5.27331Z'
                    fill='#242320'/>
            </g>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconDownload;
